import React from "react";
import { Switch, Route } from "react-router-dom";

import GoodsPage from "./Goods";
import HomePage from "./Home";
import PaymentPage from "./Payment";

function RouteIndex() {
  return (
    <Switch>
      <Route path='/goods'>
        <GoodsPage />
      </Route>
      <Route path='/payment'>
        <PaymentPage />
      </Route>
      <Route path='/qr/payment'>
        <PaymentPage />
      </Route>
      <Route path='/'>
        <HomePage />
      </Route>
    </Switch>
  );
}

export default RouteIndex;
